<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    ModalInputTag(v-show="modalStatusTag" :title="titleModalTag" :content="contentModalTag" @padre:modificarTag="modificarTag")
    ModalInputIp(v-show="modalStatusIp" :title="titleModalIp" :content="contentModalIp" @padre:modificarIp="modificarIp")
    ModalInputMacW(v-show="modalStatusMacW" :title="titleModalMacW" :content="contentModalMacW" @padre:modificarMacW="modificarMacW")
    ModalInputMacE(v-show="modalStatusMacE" :title="titleModalMacE" :content="contentModalMacE" @padre:modificarMacE="modificarMacE")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-8.is-offset-2.has-text-centered
            h1.title 
              | Listado de Artículos para Salida
              | &nbsp
              a.button.is-dark.is-rounded.is-medium(@click="backPage")
                i.fas.fa-times
            br
            router-link.a.button.is-dark.is-rounded.is-size-6.is-rounded(to="/Inventario/SalidaNueva" v-show="tipoSalida === 's'") Salida
            router-link.a.button.is-warning.is-rounded(to="/Inventario/NuevaAsignacion" v-show="tipoSalida === 'a'") Asignación
            router-link.a.button.is-dark.is-rounded.is-size-6.is-rounded(to="/Inventario/Prestamos/Nuevo" v-show="tipoSalida === 'p'") Préstamo
        .columns.has-text-centered(v-show="hayDatos")
          .column
            .table
              table#tbExistencias.table.is-striped
                thead
                  tr
                    th Artículo
                    th Ubicación
                    th Orden Compra
                    th Descripción
                    th Tag
                    th Dirección Ip
                    th MAC Addreess Wireless
                    th MAC Addreess Ethernet
                tbody
                  tr(v-for="(data, index) in articulosSelect" :key="data.id")
                    td 
                      button.delete(@click="eliminarArticulo(data)")
                      | &nbsp
                      b Serie: 
                      | {{ data.serie }}
                      br
                      small 
                        b Marca: 
                        | {{ data.marca}} | 
                        b Modelo:
                        | {{ data.modelo }}
                    td 📌 {{ data.ubicacion }}
                    td {{ data.ordenCompra }}
                    td(v-if="data.subcategoria") 
                      .control
                        .tags.has-addons
                          span.tag.is-black
                            i.fas.fa-tag
                            | &nbsp {{ data.categoria}}
                          span.tag.is-warning {{ data.subcategoria}}
                    td(v-else) 
                      span.tag.is-black {{ data.categoria}}       
                    td
                      | {{ data.tag}}
                      | &nbsp
                      a.button.is-primary.is-small.is-rounded(@click="openModalTag(data)")
                        i.fas.fa-edit
                    td
                      | {{ data.direccionIP}}
                      | &nbsp
                      a.button.is-primary.is-small.is-rounded(@click="openModalIp(data)")
                        i.fas.fa-edit
                    td
                      | {{ data.macAddressW}}
                      | &nbsp
                      a.button.is-primary.is-small.is-rounded(@click="openModalMacW(data)")
                        i.fas.fa-edit
                    td
                      | {{ data.macAddressE}}
                      | &nbsp
                      a.button.is-primary.is-small.is-rounded(@click="openModalMacE(data)")
                        i.fas.fa-edit
        .columns(v-show="!hayDatos")
          .column.is-4.is-offset-4
            .notification.is-danger No existen Registros aún en la Base de Datos.
        .columns.column-blanco
</template>

<script>
import Loader from '../shared/Loader.vue'
import HeaderInventario from './layout/HeaderInventario.vue'
import NavBarInventario from './layout/NavBarInventario.vue'
import InventarioServices from '../../services/inventario/inventario'
import ModalInputTag from './shared/ModalnputTag.vue'
import ModalInputIp from './shared/ModalnputIp.vue'
import ModalInputMacW from './shared/ModalInputMacW.vue'
import ModalInputMacE from './shared/ModalInputMacE.vue'
import { mapState } from 'vuex'

export default {
  name: 'ListaSalida',
  components: { Loader, NavBarInventario, HeaderInventario, ModalInputTag, ModalInputIp, ModalInputMacW, ModalInputMacE },
  data () {
    return {
      isLoading: true,
      articulosSelect: [],
      hayDatos: false,
      tipos: [],
      isSalida: false,
      isAsignacion: false,
      modalStatusTag: false,
      titleModalTag: '',
      contentModalTag: '',
      modalStatusIp: false,
      titleModalIp: '',
      contentModalIp: '',
      modalStatusMacW: false,
      titleModalMacW: '',
      contentModalMacW: '',
      modalStatusMacE: false,
      titleModalMacE: '',
      contentModalMacE: '',
      articuloEditado: {}
    }
  },
  watch: {
    articulos_Salida () {
      this.obtenerArticulos_Salida()
    }
  },

  methods: {
    obtenerArticulos_Salida () {
      this.articulosSelect = this.articulos_Salida
      if (this.articulosSelect.length > 0) {
        setTimeout(() => {
          this.hayDatos = true
          this.isLoading = false
        }, 250)
      } else {
        setTimeout(() => {
          this.hayDatos = false
          this.isLoading = false
        }, 250)
      }

      if (this.tipoSalida === 's') {
        this.isSalida = true
        this.isAsignacion = false
      } else {
        this.isAsignacion = true
        this.isSalida = false
      }
    },
    eliminarArticulo (art) {
      console.log(art)
      this.$store.commit('quitarArticulo_Salida', art)
    },
    openModalTag (art) {
      this.articuloEditado = art
      this.titleModalTag = 'Modificar Tag'
      this.contentModalTag = 'Escriba el tag del dispositivo.'
      this.modalStatusTag = true
    },
    openModalIp (art) {
      this.articuloEditado = art
      this.titleModalIp = 'Modificar Dirección Ip'
      this.contentModalIp = 'Escriba la dirección ip del dispositivo.'
      this.modalStatusIp = true
    },
    openModalMacW (art) {
      this.articuloEditado = art
      this.titleModalMacW = 'Modificar la MAC Address Wireless'
      this.contentModalMacW = 'Escriba la MAC Address del dispositivo.'
      this.modalStatusMacW = true
    },
    openModalMacE (art) {
      this.articuloEditado = art
      this.titleModalMacE = 'Modificar la MAC Address Ethernet'
      this.contentModalMacE = 'Escriba MAC Address del dispositivo.'
      this.modalStatusMacE = true
    },
    modificarTag (value) {
      this.modalStatusTag = false
      if (value !== 'close') {
        this.isLoading = true
        let newObj = {
          categoria: this.articuloEditado.categoria,
          direccionIP: this.articuloEditado.direccionIP,
          estado: this.articuloEditado.estado,
          fechaCompra: this.articuloEditado.fechaCompra,
          fechaReg: this.articuloEditado.fechaReg,
          garantia: this.articuloEditado.garantia,
          id: this.articuloEditado.id,
          idIngresa: this.articuloEditado.idIngresa,
          idResguardo: this.articuloEditado.idResguardo,
          id_cat: this.articuloEditado.id_cat,
          id_subcat: this.articuloEditado.id_subcat,
          ingresa: this.articuloEditado.ingresa,
          macAddressE: this.articuloEditado.macAddressE,
          macAddressW: this.articuloEditado.macAddressW,
          marca: this.articuloEditado.marca,
          modelo: this.articuloEditado.modelo,
          num: this.articuloEditado.num,
          observaciones: this.articuloEditado.observaciones,
          oficina: this.articuloEditado.oficina,
          ordenCompra: this.articuloEditado.ordenCompra,
          resguardo: this.articuloEditado.resguardo,
          serie: this.articuloEditado.serie,
          subcategoria: this.articuloEditado.subcategoria,
          tag: value,
          terminoGarantia: this.articuloEditado.terminoGarantia,
          ubicacion: this.articuloEditado.ubicacion,
          ultimoMov: this.articuloEditado.ultimoMov
        }
        this.$store.commit('quitarArticulo_Salida', this.articuloEditado)
        setTimeout(() => {
        this.$store.commit('agregarArticulos_Salida', newObj)
        this.isLoading = false
        }, 350)
      } else {
        this.modificarTag = false
        this.articuloEditado = {}
      }
    },
    modificarIp (value) {
      this.modalStatusIp = false
      if (value !== 'close') {
        this.isLoading = true
        let newObj = {
          categoria: this.articuloEditado.categoria,
          direccionIP: value,
          estado: this.articuloEditado.estado,
          fechaCompra: this.articuloEditado.fechaCompra,
          fechaReg: this.articuloEditado.fechaReg,
          garantia: this.articuloEditado.garantia,
          id: this.articuloEditado.id,
          idIngresa: this.articuloEditado.idIngresa,
          idResguardo: this.articuloEditado.idResguardo,
          id_cat: this.articuloEditado.id_cat,
          id_subcat: this.articuloEditado.id_subcat,
          ingresa: this.articuloEditado.ingresa,
          macAddressE: this.articuloEditado.macAddressE,
          macAddressW: this.articuloEditado.macAddressW,
          marca: this.articuloEditado.marca,
          modelo: this.articuloEditado.modelo,
          num: this.articuloEditado.num,
          observaciones: this.articuloEditado.observaciones,
          oficina: this.articuloEditado.oficina,
          ordenCompra: this.articuloEditado.ordenCompra,
          resguardo: this.articuloEditado.resguardo,
          serie: this.articuloEditado.serie,
          subcategoria: this.articuloEditado.subcategoria,
          tag: this.articuloEditado.tag,
          terminoGarantia: this.articuloEditado.terminoGarantia,
          ubicacion: this.articuloEditado.ubicacion,
          ultimoMov: this.articuloEditado.ultimoMov
        }
        this.$store.commit('quitarArticulo_Salida', this.articuloEditado)
        setTimeout(() => {
        this.$store.commit('agregarArticulos_Salida', newObj)
        this.isLoading = false
        }, 350)
      } else {
        this.modalStatusIp = false
        this.articuloEditado = {}
      }
    },
    modificarMacW (value) {
      this.modalStatusMacW = false
      if (value !== 'close') {
        this.isLoading = true
        let newObj = {
          categoria: this.articuloEditado.categoria,
          direccionIP: this.articuloEditado.direccionIP,
          estado: this.articuloEditado.estado,
          fechaCompra: this.articuloEditado.fechaCompra,
          fechaReg: this.articuloEditado.fechaReg,
          garantia: this.articuloEditado.garantia,
          id: this.articuloEditado.id,
          idIngresa: this.articuloEditado.idIngresa,
          idResguardo: this.articuloEditado.idResguardo,
          id_cat: this.articuloEditado.id_cat,
          id_subcat: this.articuloEditado.id_subcat,
          ingresa: this.articuloEditado.ingresa,
          macAddressW: value,
          macAddressE: this.articuloEditado.macAddressE,
          marca: this.articuloEditado.marca,
          modelo: this.articuloEditado.modelo,
          num: this.articuloEditado.num,
          observaciones: this.articuloEditado.observaciones,
          oficina: this.articuloEditado.oficina,
          ordenCompra: this.articuloEditado.ordenCompra,
          resguardo: this.articuloEditado.resguardo,
          serie: this.articuloEditado.serie,
          subcategoria: this.articuloEditado.subcategoria,
          tag: this.articuloEditado.tag,
          terminoGarantia: this.articuloEditado.terminoGarantia,
          ubicacion: this.articuloEditado.ubicacion,
          ultimoMov: this.articuloEditado.ultimoMov
        }
        this.$store.commit('quitarArticulo_Salida', this.articuloEditado)
        setTimeout(() => {
        this.$store.commit('agregarArticulos_Salida', newObj)
        this.isLoading = false
        }, 350)
      } else {
        this.modalStatusMacW = false
        this.articuloEditado = {}
      }
    },
    modificarMacE (value) {
      this.modalStatusMacE = false
      if (value !== 'close') {
        this.isLoading = true
        let newObj = {
          categoria: this.articuloEditado.categoria,
          direccionIP: this.articuloEditado.direccionIP,
          estado: this.articuloEditado.estado,
          fechaCompra: this.articuloEditado.fechaCompra,
          fechaReg: this.articuloEditado.fechaReg,
          garantia: this.articuloEditado.garantia,
          id: this.articuloEditado.id,
          idIngresa: this.articuloEditado.idIngresa,
          idResguardo: this.articuloEditado.idResguardo,
          id_cat: this.articuloEditado.id_cat,
          id_subcat: this.articuloEditado.id_subcat,
          ingresa: this.articuloEditado.ingresa,
          macAddressW: this.articuloEditado.macAddressW,
          macAddressE: value,
          marca: this.articuloEditado.marca,
          modelo: this.articuloEditado.modelo,
          num: this.articuloEditado.num,
          observaciones: this.articuloEditado.observaciones,
          oficina: this.articuloEditado.oficina,
          ordenCompra: this.articuloEditado.ordenCompra,
          resguardo: this.articuloEditado.resguardo,
          serie: this.articuloEditado.serie,
          subcategoria: this.articuloEditado.subcategoria,
          tag: this.articuloEditado.tag,
          terminoGarantia: this.articuloEditado.terminoGarantia,
          ubicacion: this.articuloEditado.ubicacion,
          ultimoMov: this.articuloEditado.ultimoMov
        }
        this.$store.commit('quitarArticulo_Salida', this.articuloEditado)
        setTimeout(() => {
        this.$store.commit('agregarArticulos_Salida', newObj)
        this.isLoading = false
        }, 350)
      } else {
        this.modalStatusMacE = false
        this.articuloEditado = {}
      }
    },
    backPage() {
      this.$router.back()
    }
  },
  created () {
    this.obtenerArticulos_Salida()
  },
  computed: {
    ...mapState(['articulos_Salida', 'tipoSalida'])
  }
}
</script>

<style lang="css" scoped>
  .table {
    margin: 10px auto;
  }
  .column-blanco {
    padding-bottom: 150px;
  }
</style>




// WEBPACK FOOTER //
// src/components/inventario_Componentes/ListaSalida.vue